import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import DashboardLayout from '../../../components/layouts/DashboardLayout';
import Loader from '../../../components/utils/Loader';
import { getAllCustomerbyID, postRedeem, transactionView } from '../../../components/actions/campaign';
import { getDate } from '../../../components/utils/helper';
import { getAllVoucher } from '../../../components/actions/auth';
import { redeemVoucher } from '../../../components/actions/voucher';
import { ToastContainer, toast } from "react-toastify";

export default function CustomerProfilePage() {
  const { id: customerID } = useParams();
  const [customer, setCustomer] = useState(null);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const [selectedPoints, setSelectedPoints] = useState(false);
  const [pointsValue, setPointsValue] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [copySuccess, setCopySuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [vouchers, setVouchers] = useState([]); // Now dynamic
  const [vouchersLoading, setVouchersLoading] = useState(false);
  const code = sessionStorage.getItem('code');

  const fetchData = () => {
    setLoading(true);

    getAllCustomerbyID(code, customerID)
      .then((res) => {
        const data = res?.data || {};
        // Map API customer details to match UI expectations
        const customerData = {
          ...data.customerDetails?.[0],
          id: customerID,
          status: 'VIP', // Mocked since not in API
          tier: 'Platinum', // Mocked since not in API
          avatar:
            'https://readdy.ai/api/search-image?query=professional%20indian%20businessman%20portrait%20photo%20with%20modern%20corporate%20background%2C%20clean%20lighting%2C%20confident%20expression&width=120&height=120&seq=customerprofile1&orientation=squarish',
          address: data.customerDetails?.[0]?.city && data.customerDetails?.[0]?.country
            ? `${data.customerDetails[0].city}, ${data.customerDetails[0].country}`
            : 'Unknown Address',
          dateOfBirth: '1985-06-15', // Mocked since not in API
          joinDate: '2024-01-15', // Mocked since not in API
          lastActivity: '2 hours ago', // Mocked since not in API
          totalPoints: data.customerWalletDetails?.[0]?.totalpoint ?? 0,
          totalSpent: data.transactions?.reduce((sum, tx) => sum + (parseFloat(tx.Amount) || 0), 0) || 0,
          totalOrders: data.transactions?.length || 0,
          averageOrderValue:
            data.transactions?.length > 0
              ? Math.round(
                data.transactions.reduce((sum, tx) => sum + (parseFloat(tx.Amount) || 0), 0) /
                data.transactions.length
              )
              : 0,
          lifetimeValue: data.customerWalletDetails?.[0]?.redeempoint ?? 0,
          walletBalance: data.customerWalletDetails?.[0]?.totalavailbalance ?? 0,
        };
        setCustomer(customerData);
        // Map transactions to match UI expectations
        const transactionData = data.transactions?.map((tx) => ({
          id: tx.transactionId,
          type: tx.isqualified === 'Y' ? 'Purchase' : 'Refund', // Simplified mapping; adjust based on API
          amount: parseFloat(tx.Amount) || 0,
          points: tx.points || 0, // Points not in API; may need adjustment
          date: tx.CreatedOn,
          description: tx.description || 'Transaction', // Description not in API; fallback
          status: 'Completed', // Mocked since not in API
          campaignId: tx.campaignId || 'CAM85587181', // Mocked fallback
          earningType: tx.earningType || 'Fix', // Mocked fallback
          earningValueType: tx.earningValueType || 'point', // Mocked fallback
          expirationDate: tx.expirationDate || tx.CreatedOn, // Mocked fallback
          redeemAfterDate: tx.redeemAfterDate || tx.CreatedOn, // Mocked fallback
          transactionType: tx.transactionType || 'earned', // Mocked fallback
          earningDate: tx.earningDate || tx.CreatedOn, // Mocked fallback
          earningValue: parseFloat(tx.Amount) || 0, // Use Amount as fallback
          isQualified: tx.isqualified === 'Y',
        })) || [];
        setTransactions(transactionData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching customer data:', error);
        setLoading(false);
      });
  }

  useEffect(() => {
    fetchData()
    fetchVoucher()
  }, []);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopySuccess('Copied!');
      setTimeout(() => setCopySuccess(''), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  const viewTransaction = async (transaction) => {
    setLoading(true);
    try {
      const res = await transactionView(code, transaction.id);
      const txData = res?.data || {};
      // Map API transaction data to match UI expectations
      const transactionDetails = {
        id: txData.transactions?.[0]?.transactionId || transaction.id,
        type: txData.transactions?.[0]?.isqualified === 'Y' ? 'Purchase' : 'Refund',
        amount: parseFloat(txData.transactions?.[0]?.Amount) || transaction.amount,
        points: transaction.points || 0, // Points not in API; retain from input
        date: txData.transactions?.[0]?.CreatedOn || transaction.date,
        description: txData.transactions?.[0]?.description || transaction.description || 'Transaction',
        status: 'Completed', // Mocked
        campaignId: txData.transactionDetails?.[0]?.campaignid || transaction.campaignId,
        earningType: txData.transactionDetails?.[0]?.earningtype || transaction.earningType,
        earningValueType: txData.transactionDetails?.[0]?.earningvaluetype || transaction.earningValueType,
        expirationDate: txData.transactionDetails?.[0]?.expirationDate || transaction.expirationDate,
        redeemAfterDate: txData.transactionDetails?.[0]?.redeemafterDate || transaction.redeemAfterDate,
        transactionType: txData.transactionDetails?.[0]?.tranType || transaction.transactionType,
        earningDate: txData.transactionDetails?.[0]?.earningdate || transaction.earningDate,
        earningValue: txData.transactionDetails?.[0]?.earningvalue || transaction.earningValue,
        isQualified: txData.transactions?.[0]?.isqualified === 'Y',
      };
      setSelectedTransaction(transactionDetails);
      setShowTransactionModal(true);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching transaction details:', error);
      setSelectedTransaction(transaction); // Fallback to input transaction
      setShowTransactionModal(true);
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'VIP':
        return 'bg-purple-100 text-purple-800';
      case 'Active':
        return 'bg-green-100 text-green-800';
      case 'Inactive':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getTierColor = (tier) => {
    switch (tier) {
      case 'Platinum':
        return 'bg-slate-800 text-white';
      case 'Gold':
        return 'bg-yellow-500 text-white';
      case 'Silver':
        return 'bg-gray-400 text-white';
      case 'Bronze':
        return 'bg-orange-600 text-white';
      default:
        return 'bg-gray-400 text-white';
    }
  };

  const getTierIcon = (tier) => {
    switch (tier) {
      case 'Platinum':
        return 'ri-vip-diamond-line';
      case 'Gold':
        return 'ri-medal-line';
      case 'Silver':
        return 'ri-award-line';
      case 'Bronze':
        return 'ri-copper-coin-line';
      default:
        return 'ri-user-line';
    }
  };
  const fetchVoucher = () => {

    setVouchersLoading(true);
    getAllVoucher(code, customerID)
      .then((res) => {
        const voucherList = res?.data || [];
        setVouchers(voucherList)
      })
      .catch((err) => {
        console.error('Error fetching vouchers:', err);
        setVouchers([]);
      })
      .finally(() => setVouchersLoading(false));


  }

  // useEffect(() => {
  //       if (activeTab === 'vouchers') {
  //   fetchVoucher()
  // }
  // }, [activeTab]);
  const getTransactionIcon = (type) => {
    switch (type) {
      case 'Purchase':
        return 'ri-shopping-cart-line';
      case 'Refund':
        return 'ri-refund-line';
      case 'Points Earned':
        return 'ri-coin-line';
      case 'Points Redeemed':
        return 'ri-gift-line';
      default:
        return 'ri-exchange-line';
    }
  };

  const getTransactionColor = (type) => {
    switch (type) {
      case 'Purchase':
        return 'text-green-600 bg-green-50';
      case 'Refund':
        return 'text-red-600 bg-red-50';
      case 'Points Earned':
        return 'text-blue-600 bg-blue-50';
      case 'Points Redeemed':
        return 'text-purple-600 bg-purple-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };


  const getVoucherStatus = (voucher) => {
    const currentDate = new Date();
    const expiryDate = new Date(voucher.ExpiryDate);

    if (voucher.IsUsed === 1) return "Used";
    if (expiryDate < currentDate) return "Expired";
    return "Active";
  };

  const getVoucherStatusColor = (status) => {
    switch (status) {
      case "Active":
        return "bg-green-100 text-green-800";
      case "Used":
        return "bg-gray-100 text-gray-800";
      case "Expired":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const handleRedeemClick = (voucher) => {
    setSelectedVoucher(voucher);
  };

  const handleConfirmRedeem = async () => {
    setIsLoading(true);
    try {
      const res = await redeemVoucher(code, customerID, selectedVoucher?.Code);
      setIsLoading(false);
      if (res?.message === 'success') {
        toast.success("Voucher redeem successfully! 🎉");
        setSelectedVoucher(null);
        fetchVoucher()
      } else {
        toast.error("Voucher  not redeem");
      }
    } catch (error) {
      setIsLoading(false);
    }

  };
  const handleCancelRedeem = () => {
    setSelectedVoucher(null);
  };

  const handlePointsClick = () => {
    setSelectedPoints(true);
    setPointsValue("");
    setError("");
  };

  const handlePointConfirm = async () => {
    const enteredValue = Number(pointsValue);
    const walletBalance = Number(customer.walletBalance || 0);

    if (!enteredValue || enteredValue <= 0) {
      setError("Please enter a valid amount.");
      return;
    }

    if (enteredValue > walletBalance) {
      setError("You have entered more than your available balance.");
      return;
    }

    setIsLoading(true);
    try {
      const res = await postRedeem(code, customerID, enteredValue);
      setIsLoading(false);
      if (res?.message === 'success') {
        fetchData()
        toast.success("Points redeem successfully! 🎉");
        setSelectedPoints(null);
      } else {
        toast.error("Points not redeem");
      }
    } catch (error) {
      setIsLoading(false);
    }
    setSelectedPoints(false);
  };

  const handleClosePoints = () => {
    setSelectedPoints(false);
    setPointsValue("");
    setError("");
  };


  return (
    <DashboardLayout>
      <div className="p-6 max-w-7xl mx-auto">
        {loading && <Loader />}
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-4 mb-4">
            <Link
              to="/customers"
              className="w-10 h-10 flex items-center justify-center text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </Link>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Customer Profile</h1>
              <p className="text-gray-600 mt-1">Detailed information and activity history</p>
            </div>
          </div>
        </div>

        {/* Customer Header Card */}
        {customer && (
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-8">
            <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
              <div className="flex items-center gap-6">
                <div class="w-24 h-24 rounded-full border-4 border-gray-200 shadow-lg flex items-center justify-center bg-gray-100">
                  <i class="ri-user-line text-5xl text-gray-500"></i>
                </div>
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <h2 className="text-2xl font-bold text-gray-900">{customer.name}</h2>
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(
                        customer.status
                      )}`}
                    >
                      {customer.status}
                    </span>
                    <div
                      className={`px-3 py-1 rounded-lg text-sm font-semibold flex items-center gap-2 ${getTierColor(
                        customer.tier
                      )}`}
                    >
                      <i className={`${getTierIcon(customer.tier)} text-sm`}></i>
                      {customer.tier} Tier
                    </div>
                  </div>
                  <div className="space-y-1 text-gray-600">
                    <p className="flex items-center gap-2">
                      <i className="ri-mail-line text-sm"></i>
                      {customer.email}
                    </p>
                    <p className="flex items-center gap-2">
                      <i className="ri-phone-line text-sm"></i>
                      {customer.mobile || 'N/A'}
                    </p>
                    <p className="flex items-center gap-2">
                      <i className="ri-map-pin-line text-sm"></i>
                      {customer.address}
                    </p>
                  </div>
                </div>
              </div>

              {/* <div className="lg:ml-auto flex gap-3">
                <button
                  className="bg-blue-500 text-white px-6 py-3 rounded-xl font-semibold hover:bg-blue-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-message-line mr-2"></i>
                  Send Message
                </button>
                <button
                  className="bg-green-500 text-white px-6 py-3 rounded-xl font-semibold hover:bg-green-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-gift-line mr-2"></i>
                  Award Points
                </button>
                <button
                  className="bg-gray-100 text-gray-600 px-4 py-3 rounded-xl hover:bg-gray-200 transition-colors cursor-pointer"
                >
                  <i className="ri-more-line"></i>
                </button>
              </div> */}
            </div>
          </div>
        )}

        {/* Stats Grid */}
        {customer && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                  <i className="ri-coin-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-gray-600 text-sm font-medium">Total Points</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {customer.totalPoints.toLocaleString()}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center">
                  <i className="ri-exchange-line text-purple-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-gray-600 text-sm font-medium">Total Transaction Count</p>
                  <p className="text-2xl font-bold text-gray-900">{customer.totalOrders}</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                  <i className="ri-money-dollar-circle-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-gray-600 text-sm font-medium">Total Transaction Amount</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {customer.totalSpent.toLocaleString()}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center">
                  <i className="ri-gift-line text-orange-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-gray-600 text-sm font-medium">Redeemed Points</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {customer.lifetimeValue.toLocaleString()}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 mb-8">
          <div className="border-b border-gray-200">
            <nav className="flex">
              {[
                { id: 'overview', label: 'Overview', icon: 'ri-user-line' },
                { id: 'transactions', label: 'Transactions', icon: 'ri-exchange-line' },
                { id: 'vouchers', label: 'Vouchers', icon: 'ri-coupon-line' },
                { id: 'wallet', label: 'Wallet Details', icon: 'ri-wallet-line' },
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 px-6 py-4 font-semibold text-sm border-b-2 transition-colors cursor-pointer ${activeTab === tab.id
                    ? 'border-blue-500 text-blue-600 bg-blue-50'
                    : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                    }`}
                >
                  <i className={`${tab.icon} text-lg`}></i>
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="p-6">
            {/* Overview Tab */}
            {activeTab === 'overview' && customer && (
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-gray-50 rounded-xl p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">Personal Information</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Date of Birth</span>
                        <span className="font-medium text-gray-900">
                          {new Date(customer.dateOfBirth).toLocaleDateString('en-IN')}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Member Since</span>
                        <span className="font-medium text-gray-900">
                          {new Date(customer.joinDate).toLocaleDateString('en-IN')}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Last Activity</span>
                        <span className="font-medium text-gray-900">{customer.lastActivity}</span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">Purchase Summary</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Total Spent</span>
                        <span className="font-semibold text-green-600">
                          {customer.totalSpent.toLocaleString()}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Average Order Value</span>
                        <span className="font-medium text-gray-900">
                          {customer.averageOrderValue.toLocaleString()}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Total Orders</span>
                        <span className="font-medium text-gray-900">{customer.totalOrders}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6">
                  <h3 className="font-semibold text-gray-900 mb-4">Loyalty Program Status</h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="text-center">
                      <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                        <i className="ri-medal-line text-blue-600 text-2xl"></i>
                      </div>
                      <p className="font-semibold text-gray-900">{customer.tier} Member</p>
                      <p className="text-gray-600 text-sm">Current Tier</p>
                    </div>
                    <div className="text-center">
                      <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-2">
                        <i className="ri-coin-line text-purple-600 text-2xl"></i>
                      </div>

                      <p className="font-semibold text-gray-900">{customer.walletBalance}</p>
                      <p className="text-gray-600 text-sm">Available Points</p>
                    </div>
                    <div className="text-center">
                      <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
                        <i className="ri-gift-line text-green-600 text-2xl"></i>
                      </div>
                      <p className="font-semibold text-gray-900">
                        {vouchers.filter((v) => v.IsUsed === 0).length}
                      </p>
                      <p className="text-gray-600 text-sm">Active Vouchers</p>
                    </div>
                  </div>
                </div>
              </div>
            )}


            {/* Transactions Tab */}
            {activeTab === 'transactions' && (
              <div className="space-y-6">
                <div className="flex justify-between items-center">
                  <h3 className="font-semibold text-gray-900">Transaction History</h3>
                  <button
                    className="bg-blue-50 text-blue-600 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-blue-100 transition-colors cursor-pointer"
                  >
                    <i className="ri-download-line mr-2"></i>
                    Export
                  </button>
                </div>
                <div className="space-y-3">
                  {transactions.length > 0 ? (
                    transactions.map((transaction) => (
                      <div key={transaction.id} className="bg-gray-50 rounded-xl p-4">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-4">
                            <div
                              className={`w-12 h-12 rounded-xl flex items-center justify-center ${getTransactionColor(
                                transaction.type
                              )}`}
                            >
                              <i className={`${getTransactionIcon(transaction.type)} text-xl`}></i>
                            </div>
                            <div>
                              <h4 className="font-semibold text-gray-900">{transaction.description}</h4>
                              <div className="flex items-center gap-4 mt-1">
                                <p className="text-gray-600 text-sm flex items-center gap-2">
                                  Transaction ID:
                                  <span className="font-medium">{transaction.id}</span>
                                  <button
                                    onClick={() => copyToClipboard(transaction.id)}
                                    className="text-blue-600 hover:text-blue-800 cursor-pointer"
                                    title="Copy Transaction ID"
                                  >
                                    <i className="ri-file-copy-line text-sm"></i>
                                  </button>
                                  {copySuccess && (
                                    <span className="text-green-600 text-xs font-medium">
                                      {copySuccess}
                                    </span>
                                  )}
                                </p>
                                <p className="text-gray-600 text-sm">
                                  Date: {getDate(transaction.date, 'DD-MM-YYYY')}
                                </p>
                                <span
                                  className={`px-2 py-1 rounded-full text-xs font-semibold ${transaction.isQualified
                                    ? 'bg-green-100 text-green-800'
                                    : 'bg-red-100 text-red-800'
                                    }`}
                                >
                                  {transaction.isQualified ? 'Qualified Transaction' : 'Not Qualified'}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-4">
                            {transaction.points !== 0 && (
                              <div className="text-right">
                                <p
                                  className={`font-semibold ${transaction.points >= 0 ? 'text-green-600' : 'text-red-600'
                                    }`}
                                >
                                  {transaction.points >= 0 ? '+' : ''}
                                  {transaction.points} points earned
                                </p>
                              </div>
                            )}
                            <button
                              onClick={() => viewTransaction(transaction)}
                              className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-blue-600 transition-colors cursor-pointer whitespace-nowrap"
                            >
                              <i className="ri-eye-line mr-2"></i>
                              View Transaction
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No transactions available</p>
                  )}
                </div>
              </div>
            )}
            {activeTab === 'vouchers' && (
              <div className="space-y-4">
                {/* <div className="flex justify-between items-center">
                  <h3 className="font-semibold text-gray-900">Customer Vouchers</h3>
                  <button className="bg-green-50 text-green-600 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-green-100 transition-colors cursor-pointer">
                    <i className="ri-add-line mr-2"></i>Issue Voucher
                  </button>
                </div> */}

                {vouchersLoading ? (
                  <div className="text-center py-10">
                    <Loader />
                    <p className="text-gray-500 mt-4">Loading vouchers...</p>
                  </div>
                ) : vouchers.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {vouchers.map((voucher) => {
                      const status = getVoucherStatus(voucher);
                      return (
                        <div
                          key={voucher.id}
                          className="bg-gray-50 rounded-xl p-6 border-l-4 border-blue-500"
                        >
                          <div className="flex justify-between items-start mb-3">
                            <div>
                              <h4 className="font-semibold text-gray-900">
                                {voucher.name}
                              </h4>
                              <p className="text-gray-600 text-sm">Code: {voucher.Code}</p>
                            </div>

                            <div className="flex items-center gap-2">
                              <span
                                className={`px-3 py-1 rounded-full text-xs font-semibold ${getVoucherStatusColor(
                                  status
                                )}`}
                              >
                                {status}
                              </span>

                              {status === "Active" && (
                                <button
                                  onClick={() => handleRedeemClick(voucher)}
                                  className="text-sm font-medium bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition"
                                >
                                  Redeem
                                </button>
                              )}
                            </div>
                          </div>

                          <div className="space-y-2">
                            <div className="flex justify-between items-center">
                              <span className="text-gray-600 text-sm">Voucher Value</span>
                              <span className="font-semibold text-blue-600">
                                {voucher.VoucherValue}
                              </span>
                            </div>
                            <div className="flex justify-between items-center">
                              <span className="text-gray-600 text-sm">Expires</span>
                              <span className="font-medium text-gray-900">
                                {voucher.ExpiryDate
                                  ? new Date(voucher.ExpiryDate).toLocaleDateString("en-IN")
                                  : "N/A"}
                              </span>
                            </div>
                            {voucher.usedDate && (
                              <div className="flex justify-between items-center">
                                <span className="text-gray-600 text-sm">Used On</span>
                                <span className="font-medium text-gray-900">
                                  {new Date(voucher.usedDate).toLocaleDateString("en-IN")}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                    {selectedVoucher && (
                      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
                        {isLoading && <Loader />}
                        <div className="bg-white rounded-xl p-6 shadow-lg w-80">
                          <h3 className="text-lg font-semibold mb-3">Redeem Voucher</h3>
                          <p className="text-gray-700 mb-5">
                            Are you sure you want to redeem this voucher?
                          </p>
                          <div className="flex justify-end gap-3">
                            <button
                              onClick={handleCancelRedeem}
                              className="px-4 py-2 text-gray-600 hover:text-gray-800"
                            >
                              No
                            </button>
                            <button
                              onClick={handleConfirmRedeem}
                              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                  </div>
                ) : (
                  <div className="text-center py-12 bg-gray-50 rounded-xl">
                    <i className="ri-coupon-3-line text-6xl text-gray-300 mb-4"></i>
                    <p className="text-gray-500">No vouchers issued to this customer yet.</p>
                  </div>
                )}
              </div>
            )}


            {activeTab === 'wallet' && customer && (
              <div className="space-y-6">
                <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-xl p-6">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="font-semibold text-gray-900">Points Overview</h3>
                    <div className="flex gap-2">
                      <Link to="/post-transaction"
                        className="bg-green-500 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-green-600 transition-colors cursor-pointer"
                      >
                        <i className="ri-add-line mr-2"></i>
                        Add Points
                      </Link>
                      <button
                        onClick={() => handlePointsClick()}
                        className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-blue-600 transition-colors cursor-pointer"
                      >
                        <i className="ri-exchange-line mr-2"></i>
                        Redeem
                      </button>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div className="text-center">
                      <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                        <i className="ri-coin-line text-blue-600 text-2xl"></i>
                      </div>
                      <p className="text-2xl font-bold text-gray-900">
                        {customer.totalPoints.toLocaleString()}
                      </p>
                      <p className="text-gray-600 text-sm">Total Points</p>
                    </div>
                    <div className="text-center">
                      <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-2">
                        <i className="ri-time-line text-red-600 text-2xl"></i>
                      </div>
                      <p className="text-2xl font-bold text-gray-900">
                        {customer.expiredPoints?.toLocaleString() ?? 0}
                      </p>
                      <p className="text-gray-600 text-sm">Expired Points</p>
                    </div>
                    <div className="text-center">
                      <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-2">
                        <i className="ri-gift-line text-orange-600 text-2xl"></i>
                      </div>
                      <p className="text-2xl font-bold text-gray-900">
                        {customer.lifetimeValue.toLocaleString()}
                      </p>
                      <p className="text-gray-600 text-sm">Redeemed Points</p>
                    </div>
                    <div className="text-center">
                      <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
                        <i className="ri-wallet-line text-green-600 text-2xl"></i>
                      </div>
                      <p className="text-2xl font-bold text-gray-900">
                        {customer.walletBalance.toLocaleString()}
                      </p>
                      <p className="text-gray-600 text-sm">Available Points</p>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-gray-50 rounded-xl p-6">
                    <h4 className="font-semibold text-gray-900 mb-4">Recent Points Activity</h4>
                    <div className="space-y-3">
                      {transactions.slice(0, 3).map((transaction) => (
                        <div
                          key={transaction.id}
                          className="flex items-center justify-between"
                        >
                          <div className="flex items-center gap-3">
                            <div
                              className={`w-8 h-8 rounded-lg flex items-center justify-center ${getTransactionColor(
                                transaction.type
                              )}`}
                            >
                              <i
                                className={`${getTransactionIcon(transaction.type)} text-sm`}
                              ></i>
                            </div>
                            <div>
                              <p className="font-medium text-gray-900 text-sm">{transaction.type}</p>
                              <p className="text-gray-600 text-xs">
                                {getDate(transaction.date, 'DD-MM-YYYY')}
                              </p>
                            </div>
                          </div>
                          <div className="text-right">
                            {transaction.points !== 0 && (
                              <p
                                className={`font-semibold text-sm ${transaction.points >= 0 ? 'text-green-600' : 'text-red-600'
                                  }`}
                              >
                                {transaction.points >= 0 ? '+' : ''}
                                {transaction.points} pts
                              </p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-6">
                    <h4 className="font-semibold text-gray-900 mb-4">Points Breakdown</h4>
                    <div className="space-y-4">
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">Total Points Earned</span>
                        <span className="font-semibold text-green-600">
                          +{customer.totalPoints.toLocaleString()}
                        </span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">Points Redeemed</span>
                        <span className="font-semibold text-red-600">
                          -{customer.lifetimeValue.toLocaleString()}
                        </span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">Points Expired</span>
                        <span className="font-semibold text-red-600">
                          -{customer.expiredPoints?.toLocaleString() ?? 0}
                        </span>
                      </div>
                      <div className="flex justify-between items-center pt-2 border-t border-gray-200">
                        <span className="text-gray-900 font-semibold">Available Balance</span>
                        <span className="font-bold text-blue-600">
                          {customer.walletBalance.toLocaleString()}
                        </span>
                      </div>
                      <div className="bg-blue-50 rounded-lg p-3 mt-4">
                        <p className="text-blue-600 text-sm font-medium">
                          <i className="ri-information-line mr-2"></i>
                          Points expire in 12 months from earning date
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {selectedPoints && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
                    {isLoading && <Loader />}
                    <div className="bg-white rounded-xl p-6 shadow-lg w-100">
                      <h3 className="text-lg font-semibold mb-3 text-gray-900">
                        Redeem Points
                      </h3>
                      <p className="text-gray-700 mb-4">
                        Enter amount to redeem (Available Balance:{" "}
                        <strong>{customer.walletBalance}</strong>)
                      </p>

                      <input
                        type="number"
                        className={`w-full border ${error ? "border-red-400" : "border-gray-300"
                          } rounded-lg px-3 py-2 mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        placeholder="Enter redeem value"
                        value={pointsValue}
                        onChange={(e) => {
                          setPointsValue(e.target.value);
                          if (error) setError("");
                        }}
                      />
                      {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

                      <div className="flex justify-end gap-3 mt-3">
                        <button
                          onClick={handleClosePoints}
                          className="px-4 py-2 text-gray-600 hover:text-gray-800"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handlePointConfirm}
                          className="px-4 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700"
                        >
                          Redeem
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {showTransactionModal && selectedTransaction && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-gray-900">Transaction View</h2>
                <button
                  onClick={() => setShowTransactionModal(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>

              <div className="space-y-6">
                {/* Basic Info */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm font-medium text-gray-600 mb-1">Transaction ID:</p>
                    <div className="flex items-center gap-2">
                      <p className="text-sm text-gray-900 font-mono">{selectedTransaction.id}</p>
                      <button
                        onClick={() => copyToClipboard(selectedTransaction.id)}
                        className="text-blue-600 hover:text-blue-800 cursor-pointer"
                        title="Copy Transaction ID"
                      >
                        <i className="ri-file-copy-line text-sm"></i>
                      </button>
                      {copySuccess && (
                        <span className="text-green-600 text-xs font-medium">{copySuccess}</span>
                      )}
                    </div>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-600 mb-1">Customer ID:</p>
                    <p className="text-sm text-gray-900 font-mono">{customerID}</p>
                  </div>
                </div>

                <hr className="border-gray-200" />

                {/* Transaction Details */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Transaction Details</h3>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm font-medium text-gray-600 mb-1">Date:</p>
                        <p className="text-sm text-gray-900">
                          {getDate(selectedTransaction.date, 'DD-MM-YYYY')}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-gray-600 mb-1">Is Qualified:</p>
                        <p className="text-sm text-gray-900">
                          {selectedTransaction.isQualified ? 'Y' : 'N'}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-gray-600 mb-1">Amount:</p>
                        <p className="text-sm text-gray-900">{selectedTransaction.amount}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Qualified Details */}
                {selectedTransaction.isQualified && (
                  <>
                    <hr className="border-gray-200" />
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-4">Qualified Details</h3>
                      <div className="bg-gray-50 rounded-lg p-4 space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <p className="text-sm font-medium text-gray-600 mb-1">Campaign ID:</p>
                            <p className="text-sm text-gray-900">{selectedTransaction.campaignId}</p>
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-600 mb-1">Earning Date:</p>
                            <p className="text-sm text-gray-900">
                              {getDate(selectedTransaction.earningDate, 'DD-MM-YYYY')}
                            </p>
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-600 mb-1">Earning Type:</p>
                            <p className="text-sm text-gray-900">{selectedTransaction.earningType}</p>
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-600 mb-1">Earning Value:</p>
                            <p className="text-sm text-gray-900">{selectedTransaction.earningValue}</p>
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-600 mb-1">Earning Value Type:</p>
                            <p className="text-sm text-gray-900">{selectedTransaction.earningValueType}</p>
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-600 mb-1">Redeem After Date:</p>
                            <p className="text-sm text-gray-900">
                              {getDate(selectedTransaction.redeemAfterDate, 'DD-MM-YYYY')}
                            </p>
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-600 mb-1">Expiration Date:</p>
                            <p className="text-sm text-gray-900">
                              {getDate(selectedTransaction.expirationDate, 'DD-MM-YYYY')}
                            </p>
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-600 mb-1">Transaction Type:</p>
                            <p className="text-sm text-gray-900">{selectedTransaction.transactionType}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div className="flex justify-end pt-4">
                  <button
                    onClick={() => setShowTransactionModal(false)}
                    className="bg-blue-500 text-white px-6 py-3 rounded-xl font-semibold hover:bg-blue-600 transition-colors cursor-pointer"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer position="top-right" autoClose={2000} />
    </DashboardLayout>
  );
}